import { defineMessages } from 'react-intl'

const messages = defineMessages({
  title: {
    id: 'commonSettings.impersonation.title',
    description: 'Impersonation grants page title',
    defaultMessage: 'Impersonation grants',
  },
  forbiddenTitle: {
    id: 'commonSettings.impersonation.forbiddenTitle',
    description: 'Forbidden panel title for non-Global-Admin users',
    defaultMessage: 'Access denied',
  },
  forbiddenBody: {
    id: 'commonSettings.impersonation.forbiddenBody',
    description: 'Forbidden panel body for non-Global-Admin users',
    defaultMessage: 'Impersonation grants are available to platform Global Admins only.',
  },
  // Table columns
  statusColumn: {
    id: 'commonSettings.impersonation.statusColumn',
    description: 'Status column header',
    defaultMessage: 'Status',
  },
  grantorColumn: {
    id: 'commonSettings.impersonation.grantorColumn',
    description: 'Grantor column header',
    defaultMessage: 'Grantor',
  },
  granteeColumn: {
    id: 'commonSettings.impersonation.granteeColumn',
    description: 'Grantee column header',
    defaultMessage: 'Grantee',
  },
  targetColumn: {
    id: 'commonSettings.impersonation.targetColumn',
    description: 'Target column header',
    defaultMessage: 'Target user',
  },
  targetTenantColumn: {
    id: 'commonSettings.impersonation.targetTenantColumn',
    description: 'Target tenant column header',
    defaultMessage: 'Target tenant',
  },
  grantedAtColumn: {
    id: 'commonSettings.impersonation.grantedAtColumn',
    description: 'Granted-at column header',
    defaultMessage: 'Granted at',
  },
  expiresAtColumn: {
    id: 'commonSettings.impersonation.expiresAtColumn',
    description: 'Expires-at column header',
    defaultMessage: 'Expires at',
  },
  reasonColumn: {
    id: 'commonSettings.impersonation.reasonColumn',
    description: 'Reason column header',
    defaultMessage: 'Reason',
  },
  userIdShort: {
    id: 'commonSettings.impersonation.userIdShort',
    description: 'Prefix for a user id shown in a table cell',
    defaultMessage: 'User #{id}',
  },
  // Status badges
  statusActive: {
    id: 'commonSettings.impersonation.statusActive',
    description: 'Active grant status',
    defaultMessage: 'Active',
  },
  statusUsed: {
    id: 'commonSettings.impersonation.statusUsed',
    description: 'Used (in-session) grant status',
    defaultMessage: 'In use',
  },
  statusExpired: {
    id: 'commonSettings.impersonation.statusExpired',
    description: 'Expired grant status',
    defaultMessage: 'Expired',
  },
  statusRevoked: {
    id: 'commonSettings.impersonation.statusRevoked',
    description: 'Revoked grant status',
    defaultMessage: 'Revoked',
  },
  // Filters
  filterStatus: {
    id: 'commonSettings.impersonation.filterStatus',
    description: 'Status filter label',
    defaultMessage: 'Status',
  },
  filterStatusAll: {
    id: 'commonSettings.impersonation.filterStatusAll',
    description: 'Status filter all option',
    defaultMessage: 'All statuses',
  },
  filterTenant: {
    id: 'commonSettings.impersonation.filterTenant',
    description: 'Tenant filter label',
    defaultMessage: 'Target tenant id',
  },
  filterGrantee: {
    id: 'commonSettings.impersonation.filterGrantee',
    description: 'Grantee filter label',
    defaultMessage: 'Grantee user id',
  },
  filterApply: {
    id: 'commonSettings.impersonation.filterApply',
    description: 'Apply filters button',
    defaultMessage: 'Apply',
  },
  filterClear: {
    id: 'commonSettings.impersonation.filterClear',
    description: 'Clear filters button',
    defaultMessage: 'Clear',
  },
  hasMoreNotice: {
    id: 'commonSettings.impersonation.hasMoreNotice',
    description: 'Notice shown when the server capped the grants list',
    defaultMessage: 'Showing the first 500 grants. Narrow the filters to see more.',
  },
  // New Grant modal
  newGrant: {
    id: 'commonSettings.impersonation.newGrant',
    description: 'New grant button / modal title',
    defaultMessage: 'New grant',
  },
  granteeLabel: {
    id: 'commonSettings.impersonation.granteeLabel',
    description: 'Grantee field label',
    defaultMessage: 'Grantee (impersonator) user id',
  },
  granteeSelf: {
    id: 'commonSettings.impersonation.granteeSelf',
    description: 'Grantee self pill',
    defaultMessage: 'Self (you)',
  },
  granteeUseSelf: {
    id: 'commonSettings.impersonation.granteeUseSelf',
    description: 'Reset grantee to self button',
    defaultMessage: 'Use self',
  },
  targetLabel: {
    id: 'commonSettings.impersonation.targetLabel',
    description: 'Target field label',
    defaultMessage: 'Target user id',
  },
  targetHelp: {
    id: 'commonSettings.impersonation.targetHelp',
    description: 'Target field helper text',
    defaultMessage: 'The user to be impersonated. Must be an active, non-admin user.',
  },
  reasonLabel: {
    id: 'commonSettings.impersonation.reasonLabel',
    description: 'Reason field label',
    defaultMessage: 'Reason',
  },
  expiresInLabel: {
    id: 'commonSettings.impersonation.expiresInLabel',
    description: 'Expires-in chips label',
    defaultMessage: 'Grant valid for',
  },
  expiresIn1h: {
    id: 'commonSettings.impersonation.expiresIn1h',
    description: '1 hour expiry chip',
    defaultMessage: '1 hour',
  },
  expiresIn2h: {
    id: 'commonSettings.impersonation.expiresIn2h',
    description: '2 hour expiry chip',
    defaultMessage: '2 hours',
  },
  expiresIn4h: {
    id: 'commonSettings.impersonation.expiresIn4h',
    description: '4 hour expiry chip',
    defaultMessage: '4 hours',
  },
  expiresIn8h: {
    id: 'commonSettings.impersonation.expiresIn8h',
    description: '8 hour expiry chip',
    defaultMessage: '8 hours',
  },
  granteeRequired: {
    id: 'commonSettings.impersonation.granteeRequired',
    description: 'Grantee required validation',
    defaultMessage: 'A grantee user is required',
  },
  targetRequired: {
    id: 'commonSettings.impersonation.targetRequired',
    description: 'Target required validation',
    defaultMessage: 'A target user is required',
  },
  reasonRequired: {
    id: 'commonSettings.impersonation.reasonRequired',
    description: 'Reason required validation',
    defaultMessage: 'A reason is required',
  },
  createSubmit: {
    id: 'commonSettings.impersonation.createSubmit',
    description: 'Create grant submit button',
    defaultMessage: 'Create grant',
  },
  cancel: {
    id: 'commonSettings.impersonation.cancel',
    description: 'Cancel button',
    defaultMessage: 'Cancel',
  },
  createSuccess: {
    id: 'commonSettings.impersonation.createSuccess',
    description: 'Grant created success toast',
    defaultMessage: 'Impersonation grant created',
  },
  // Revoke
  revoke: {
    id: 'commonSettings.impersonation.revoke',
    description: 'Revoke row action',
    defaultMessage: 'Revoke',
  },
  revokeConfirmTitle: {
    id: 'commonSettings.impersonation.revokeConfirmTitle',
    description: 'Revoke confirm dialog title',
    defaultMessage: 'Revoke this grant?',
  },
  revokeConfirmBody: {
    id: 'commonSettings.impersonation.revokeConfirmBody',
    description: 'Revoke confirm dialog body',
    defaultMessage:
      'Revoking ends any active session under this grant immediately and it can no longer be used.',
  },
  revokeReasonLabel: {
    id: 'commonSettings.impersonation.revokeReasonLabel',
    description: 'Label above the existing reason in the revoke dialog',
    defaultMessage: 'Grant reason',
  },
  revokeSuccess: {
    id: 'commonSettings.impersonation.revokeSuccess',
    description: 'Grant revoked success toast',
    defaultMessage: 'Impersonation grant revoked',
  },
  // Impersonation banner (R2, WI 615) — the persistent strip shown app-wide while a session is active.
  bannerText: {
    id: 'commonSettings.impersonation.bannerText',
    description: 'Impersonation banner primary text',
    defaultMessage: 'You are impersonating {name} ({email}) in {tenant}.',
  },
  bannerEndsIn: {
    id: 'commonSettings.impersonation.bannerEndsIn',
    description: 'Impersonation banner expiry countdown',
    defaultMessage: 'Ends in {time}',
  },
  bannerStop: {
    id: 'commonSettings.impersonation.bannerStop',
    description: 'Stop-impersonating button on the banner',
    defaultMessage: 'Stop impersonating',
  },
  // Start session (R3, WI 605/609)
  startAction: {
    id: 'commonSettings.impersonation.startAction',
    description: 'Start-impersonation row action',
    defaultMessage: 'Start',
  },
  startConfirmTitle: {
    id: 'commonSettings.impersonation.startConfirmTitle',
    description: 'Start-session confirm dialog title',
    defaultMessage: 'Start impersonating this user?',
  },
  startConfirmBody: {
    id: 'commonSettings.impersonation.startConfirmBody',
    description: 'Start-session confirm dialog body',
    defaultMessage:
      'You will begin acting as the target user across the app. You may be asked to re-authenticate first. The session ends automatically when the grant expires, or when you stop it.',
  },
  startConfirm: {
    id: 'commonSettings.impersonation.startConfirm',
    description: 'Start-session confirm button',
    defaultMessage: 'Start session',
  },
  startStepUpFailed: {
    id: 'commonSettings.impersonation.startStepUpFailed',
    description: 'Toast when step-up re-authentication did not satisfy the impersonation start',
    defaultMessage:
      'Could not start the impersonation session — additional verification was not completed. Please try again.',
  },
  // Break-glass bulk-revoke (R5, WI 619)
  bulkRevoke: {
    id: 'commonSettings.impersonation.bulkRevoke',
    description: 'Break-glass revoke-all button',
    defaultMessage: 'Revoke all sessions',
  },
  bulkRevokeTitle: {
    id: 'commonSettings.impersonation.bulkRevokeTitle',
    description: 'Revoke-all confirm dialog title',
    defaultMessage: 'Revoke ALL active impersonation sessions?',
  },
  bulkRevokeBody: {
    id: 'commonSettings.impersonation.bulkRevokeBody',
    description: 'Revoke-all confirm dialog body',
    defaultMessage:
      'This ends every active impersonation session across the entire platform immediately — a break-glass action. It may require re-authentication. To confirm, type {phrase} below.',
  },
  bulkRevokeInputLabel: {
    id: 'commonSettings.impersonation.bulkRevokeInputLabel',
    description: 'Revoke-all typed-confirm input label',
    defaultMessage: 'Confirmation phrase',
  },
  bulkRevokeConfirm: {
    id: 'commonSettings.impersonation.bulkRevokeConfirm',
    description: 'Revoke-all confirm button',
    defaultMessage: 'Revoke all sessions',
  },
  bulkRevokeSuccess: {
    id: 'commonSettings.impersonation.bulkRevokeSuccess',
    description: 'Revoke-all success toast',
    defaultMessage: 'Ended {count} active impersonation session(s)',
  },
  // Grant-history: row-expansion sessions + events badge + CSV export (R5, WI 612)
  eventsBadge: {
    id: 'commonSettings.impersonation.eventsBadge',
    description: 'Impersonation events (last 30 days) badge',
    defaultMessage: '{count} impersonation events in the last 30 days',
  },
  exportCsv: {
    id: 'commonSettings.impersonation.exportCsv',
    description: 'Export grants CSV button',
    defaultMessage: 'Export CSV',
  },
  sessionsLoading: {
    id: 'commonSettings.impersonation.sessionsLoading',
    description: 'Loading a grant’s sessions',
    defaultMessage: 'Loading sessions…',
  },
  sessionsError: {
    id: 'commonSettings.impersonation.sessionsError',
    description: 'Error loading a grant’s sessions',
    defaultMessage: 'Could not load the sessions for this grant.',
  },
  sessionsNone: {
    id: 'commonSettings.impersonation.sessionsNone',
    description: 'No sessions under a grant',
    defaultMessage: 'No sessions have been started under this grant.',
  },
  sessionStarted: {
    id: 'commonSettings.impersonation.sessionStarted',
    description: 'Session started column',
    defaultMessage: 'Started',
  },
  sessionEnded: {
    id: 'commonSettings.impersonation.sessionEnded',
    description: 'Session ended column',
    defaultMessage: 'Ended',
  },
  sessionActive: {
    id: 'commonSettings.impersonation.sessionActive',
    description: 'Active session chip',
    defaultMessage: 'Active',
  },
  sessionEndReasonColumn: {
    id: 'commonSettings.impersonation.sessionEndReasonColumn',
    description: 'Session end-reason column',
    defaultMessage: 'End reason',
  },
  sessionEndedBy: {
    id: 'commonSettings.impersonation.sessionEndedBy',
    description: 'Session ended-by column',
    defaultMessage: 'Actioned by',
  },
  endReasonUserEnded: {
    id: 'commonSettings.impersonation.endReasonUserEnded',
    description: 'End reason 1',
    defaultMessage: 'Ended by user',
  },
  endReasonGrantExpired: {
    id: 'commonSettings.impersonation.endReasonGrantExpired',
    description: 'End reason 2',
    defaultMessage: 'Grant expired',
  },
  endReasonGrantRevoked: {
    id: 'commonSettings.impersonation.endReasonGrantRevoked',
    description: 'End reason 3',
    defaultMessage: 'Grant revoked',
  },
  endReasonSignedOut: {
    id: 'commonSettings.impersonation.endReasonSignedOut',
    description: 'End reason 4',
    defaultMessage: 'Signed out',
  },
  endReasonAdminTerminated: {
    id: 'commonSettings.impersonation.endReasonAdminTerminated',
    description: 'End reason 5',
    defaultMessage: 'Admin terminated',
  },
  endReasonTokenRevoked: {
    id: 'commonSettings.impersonation.endReasonTokenRevoked',
    description: 'End reason 6',
    defaultMessage: 'Token revoked',
  },
  // Session-activity drawer (R5, WI 616)
  activityLink: {
    id: 'commonSettings.impersonation.activityLink',
    description: 'Banner button that opens the session-activity drawer',
    defaultMessage: 'View session activity',
  },
  activityTitle: {
    id: 'commonSettings.impersonation.activityTitle',
    description: 'Session-activity drawer title',
    defaultMessage: 'Session activity',
  },
  activityScopeNote: {
    id: 'commonSettings.impersonation.activityScopeNote',
    description: 'Drawer header note about the User-Management-only scope',
    defaultMessage:
      'Showing activity from User Management only. Full audit history is available via the platform audit dashboard.',
  },
  activityLoading: {
    id: 'commonSettings.impersonation.activityLoading',
    description: 'Drawer loading state',
    defaultMessage: 'Loading activity…',
  },
  activityError: {
    id: 'commonSettings.impersonation.activityError',
    description: 'Drawer error state',
    defaultMessage: 'Couldn’t load session activity.',
  },
  activityEmpty: {
    id: 'commonSettings.impersonation.activityEmpty',
    description: 'Drawer empty state',
    defaultMessage: 'No activity yet in this session',
  },
  activityRefresh: {
    id: 'commonSettings.impersonation.activityRefresh',
    description: 'Drawer refresh button',
    defaultMessage: 'Refresh',
  },
  activityClose: {
    id: 'commonSettings.impersonation.activityClose',
    description: 'Drawer close button',
    defaultMessage: 'Close',
  },
  activityCapWarning: {
    id: 'commonSettings.impersonation.activityCapWarning',
    description: 'Drawer footer shown when the row cap is hit',
    defaultMessage: 'Showing {count} most recent — refresh for newer',
  },
})

export default messages
